import { Direction } from '@angular/cdk/bidi';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Angulartics2Segment } from 'angulartics2';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { RequestDialogComponent } from '../request-dialog/request-dialog.component';

@Component({
  selector: 'ten-manager-special-request',
  templateUrl: './manager-special-request.component.html',
  styleUrls: ['./manager-special-request.component.scss'],
  standalone: true,
  imports: [MatLegacyButtonModule, TourMatMenuModule, MatIconModule],
})
export class ManagerSpecialRequestComponent {
  private submitted = false;
  constructor(
    public dialog: MatDialog,
    private angulartics2Segment: Angulartics2Segment
  ) {}

  /*
    Open request form dialog
  */
  openDialog() {
    const direction = document.querySelector('html')?.dir as Direction;

    const dialogRef = this.dialog.open(RequestDialogComponent, {
      width: '550px',
      data: { submitted: this.submitted },
      direction,
    });

    dialogRef.afterClosed().subscribe((_result) => undefined);

    this.angulartics2Segment.eventTrack('Custom Request Clicked', {});
  }
}
